module.exports = __webpack_public_path__ + "242258c0e6393c6b8e58549df07bceca.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-04-12/whats-new.html
// module id = 2240
// module chunks = 0